import { FC } from 'react';
import * as S from './styles';

interface Props {
  leftTitle: string;
  leftIconUrl?: string;
  rightTitle: string;
  rightIconUrl?: string;
}

export const DictionaryHeader: FC<Props> = ({
  leftTitle,
  leftIconUrl,
  rightTitle,
  rightIconUrl,
}) => {
  return (
    <S.HeaderWrapper>
      <S.RowWrapper>
        <S.Icon src={leftIconUrl} alt="" data-testid="DictionaryHeader-leftIconUrl" />
        <S.Title>{leftTitle}</S.Title>
      </S.RowWrapper>
      <S.RowWrapper>
        <S.Icon src={rightIconUrl} alt="" data-testid="DictionaryHeader-rightIconUrl" />
        <S.Title>{rightTitle}</S.Title>
      </S.RowWrapper>
    </S.HeaderWrapper>
  );
};
